export default __webpack_public_path__ + "static/media/avatar.b20741a5.jpg";